import { memo, useCallback, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { QueryDropdown } from 'basic-components';
import { DropdownService, globalActions } from 'primary-components';

import getApiConfig from 'api/ApiConfig';

import { useQueryClient } from '@tanstack/react-query';

const EMPTY_ARRAY = [];
const EMPTY_OBJ = {};
const Group = ({
  value,
  onChange,
  size = undefined,
  writeOnly = false,
  extraGroupQuery = undefined,
  dependsOnParam = EMPTY_OBJ,
  menuPortalTarget = undefined,
  ref,
  ...props
}) => {
  const dispatch = useDispatch(),
        getApiConfigLocal = useCallback(() => dispatch(getApiConfig()), [dispatch]),
        queryClient = useQueryClient(),
        [groupQuery, setGroupQuery] = useState(),
        provider = useMemo(() => dependsOnParam?.value || dependsOnParam?.defaultValue || undefined, [dependsOnParam]),
        { fetchNextPage: fetchMoreGroups, isFetching: isFetchingGroups, isFetchingNextPage: isFetchingNextPageGroups, data: groups = EMPTY_ARRAY } = DropdownService.useQueryGroups({
          queryClient,
          input: groupQuery,
          getApiConfig: getApiConfigLocal,
          writeOnly,
          withDescription: true,
          extraQuery: extraGroupQuery,
          provider
        }),
        resolvedDefaultValue = useMemo(() => {
          if(value === "") {
            return undefined;
          }
          if(String(value).startsWith("{ID:")) {
            return "No access to the choosen group."
          }
          return String(value)
        }, [value]),
        groupRef = useRef(),
        onChangeLocal = useCallback((value, { data, ...props }) => {
          if(data?.isPublic) {
            dispatch(globalActions.getToastsStore()).warning("The selected group is public. Do you want to proceed?", "Selected group is public", {
              withCancel: false,
              confirmText: "Confirm",
              confirmAction: () => {
                onChange(value, { data, ...props })
              },
              cancelAction: () => {
                const localRef = ref ? ref : groupRef
                localRef?.current.dropdown.current.setValue(resolvedDefaultValue)
              }
            })
          } else {
            onChange(value, { data, ...props })
          }
        }, [dispatch, onChange, ref, resolvedDefaultValue])

  return (
    <QueryDropdown
        {...props}
        defaultValue={resolvedDefaultValue}
        fetchNextPage={fetchMoreGroups}
        isFetching={isFetchingGroups || isFetchingNextPageGroups}
        menuPortalTarget={menuPortalTarget || document.body}
        onChange={onChangeLocal}
        onInputChange={setGroupQuery}
        options={groups}
        ref={ref || groupRef}
        size={size}
    />
  )
}

Group.displayName = "Group"

Group.propTypes = {
  dependsOnParam: PropTypes.object,
  extraGroupQuery: PropTypes.string,
  menuPortalTarget: PropTypes.any,
  onChange: PropTypes.func.isRequired, 
  size: PropTypes.string,
  value: PropTypes.any.isRequired,
  writeOnly: PropTypes.bool,
}

export default memo(Group);
